import axios from 'axios'
import { Indicator } from 'mint-ui'
import { Toast } from 'vant';
import apiConfig from '../../config/api.config.js'
axios.defaults.baseURL = apiConfig.baseURL;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
axios.defaults.headers.common['Channel'] = '2'
// if(window.localStorage.getItem('Authorization') != null){
//   axios.defaults.headers.common['Authorization'] = 'Bearer '+window.localStorage.getItem('Authorization');
// }
let Indicatorinstance, loadCount = 0;
console.log('axios', axios);
// http request 拦截器
axios.interceptors.request.use(
  config => {
    let token = window.localStorage.getItem('Authorization');
    if (token) {
      token = 'Bearer' + ' ' + token.replace(/'|"/g, '') // 把token加入到默认请求参数中
      config.headers.common['Authorization'] = token
    }
    loadCount++

    if (config.notloading == 'yes') {//不展示加载loading图片
      console.log('bujiazai')
    } else {
      Indicatorinstance = Indicator.open()
    }

    return config;
  },
  err => {
    loadCount--
    if (!loadCount) {
      Indicator.close();
    }    //关闭加载前，记得重新定义实例
    return Promise.reject(err);
  });
// http response 拦截器
axios.interceptors.response.use(
  response => {
    loadCount--
    if (!loadCount) {
      Indicator.close();
    }
    
    return response;
  },
  error => {
    loadCount--
    if (!loadCount) {
      Indicator.close();
    }
    return error.response;

  });
export default axios



// WEBPACK FOOTER //
// ./src/api/axios.js